import { render, staticRenderFns } from "./activity-sever-list.vue?vue&type=template&id=3f0ad342&"
import script from "./activity-sever-list.vue?vue&type=script&lang=js&"
export * from "./activity-sever-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports